<template>
    <div class="help-center-content">
        <h4>寻找任务</h4>
        <p class="title">1.  海选任务是什么？</p>
        <p class="content">海选任务是指作家或出版社以任务的形式公开招募主播。作家/出版社会在海选任务中说明录制内容、周期、佣金和分成比例等，您可以根据自己的喜好自由参加海选选拔。</p>
        <p class="title">2.  如何参加海选任务？</p>
        <p class="content">在“我有好声音”页面，选择“去找海选任务”，进入海选任务页面。在主播工作台，也可以去找任务哦。<br>
            您可以根据个人情况挑选合适的海选任务。选定任务以后，根据海选任务提供的素材，任选一段进行演播，时长在5分钟左右。建议您挑选包含对话情节的内容进行演播，这样有利于展现您的声音表现力喔。在任务详情页，点击“参加海选”，录制并上传声音样本，就意味着成功参加海选。
        </p>
        <p class="title">3.  海选任务的任务状态都是什么意思呢？</p>
        <p class="content">处于海选中的任务，主播可以自由参选。而处于选拔中和制作中的任务，就说明不能再参加选拔了。</p>
        <p class="title">4.  如何知道我有没有被选拔上呢？</p>
        <p class="content">如果您参加的海选任务被选拔上，您会收到选拔成功的消息。在主播工作台，请注意查看您的消息。</p>
        <p class="title">5.  可以同时参加多个海选任务吗？</p>
        <p class="content">可以。多参加试音能够提高中选几率。</p>
        <p class="title">6.  海选失败，对我有什么影响吗？</p>
        <p class="content">没有。这次的失败是为了迎接下一次成功的到来。坚持尝试，您一定可以找到心仪的海选任务的。</p>
        <p class="title">7.  除了海选任务，还有什么方式可以接任务呢？</p>
        <p class="content">您还可以通过编辑个人声音标签，选择自己擅长的作品类型并添加试音，我们将根据您所选择的类型为您推荐相应的版权作品播讲。</p>
        <p class="title">8.  声音标签是什么？</p>
        <p class="content">声音标签是用来描述你个人声音优势的关键字词。您可以定义自己擅长播讲的作品类型。比如：浪漫言情等。</p>
        <p class="title">9.  如何添加声音标签？</p>
        <p class="content">在“主播工作台”中选择“声音标签”，开始添加声音标签。</p>
    </div>
</template>
<script>
  import axios from 'axios';
  export default {
    components: {
    },
    data() {
      return {

      }
    },
    computed: {

    }
  }

</script>
<style lang="sass" scoped>
    @import "../../../sass/help-center.scss";
    @import "../../../sass/icons.scss";
</style>



// WEBPACK FOOTER //
// SearchTask.vue?189b6490